'use client'

import { Button, Typography } from "antd"
import { deleteAssetsThunk } from "features/assets/model/slice/assetsSlice"
import { BoardToolbarAction } from "shared/constants/toolbar"
import { selectModalData, selectModalType } from "features/common/model/selectors/modalSelectors"
import { closeModal } from "features/common/model/slice/moadlSlice"
import { NOTIFICATION_TYPES, showNotification } from "features/common/notifications"
import { getFilesPreviewIsPublicLinkSelector } from "features/files-preview/model/selectors/filesPreviewSelectors"
import { removeAssetsPublicLinkThunk } from "features/public-link-files/model/slice/publicLinkFilesSlice"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { BaseModal } from "shared/ui/BaseModal"
import { styled } from "styled-components"


export const RemoveFromBoardModal = () => {
  const dispatch = useAppDispatch()
  const modalType = useAppSelector(selectModalType)
  const modalData = useAppSelector(selectModalData)
  const isPublicLink = useAppSelector(getFilesPreviewIsPublicLinkSelector)

  const isSingleItem = modalData?.items?.length === 1

  const handleCancel = () => {
    dispatch(closeModal())  
  }

  const handleConfirm = async () => {
    handleCancel()
    if (isPublicLink) {
      await dispatch(removeAssetsPublicLinkThunk({ ids: modalData?.ids }))
    } else {
      await dispatch(deleteAssetsThunk({ ids: modalData?.ids }))
    }
    showNotification({
      type: NOTIFICATION_TYPES.SUCCESS,
      title: isSingleItem ? 'Asset removed from board' : `${modalData?.items?.length} assets removed from board`,
      message: isSingleItem ? 'Asset removed from board successfully' : 'Assets removed from board successfully',
    })
  }

  return (
    <BaseModal
      title={`Remove from Board?`}
      isOpen={modalType === BoardToolbarAction.RemoveFromBoard}
      onClose={handleCancel}
    >
      <SContent>
        <SModalDescription>
          {isSingleItem ? (
            <>
      This asset will be removed from this board, but won’t be deleted.
              <br />
      It’ll still be available in All Assets or in other boards where it’s been added.

              {isPublicLink && (
                <>
                  <br />
          Please note: this board is shared, so any changes made here will be reflected in the original board.
                </>
              )}
            </>
          ) : (
            <>
      These assets will be removed from this board, but won’t be deleted.
              <br />
      They’ll still be available in All Assets or in other boards where they’ve been added.

              {isPublicLink && (
                <>
                  <br />
          Please note: this board is shared, so any changes made here will be reflected in the original board.
                </>
              )}
            </>
          )}
        </SModalDescription>
        
        <SButtonsContainer>
          <Button 
            size="large"
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <Button
            size="large"
            type="primary"
            onClick={handleConfirm}
          >
            Remove
          </Button>
        </SButtonsContainer>
      </SContent>   
    </BaseModal>
  )
}

const SContent = styled.div`
  margin-top: 16px;
`

const SButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
` 

const SModalDescription = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`